import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "rtb" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TableauPopup"], {
    ref: "popup",
    width: 400,
    title: "Contact Owner",
    submitText: "Send",
    status: $setup.status,
    statusMessage: $setup.statusMessage,
    canSubmit: $setup.canSend,
    onSubmitted: $setup.send
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode($setup["TableauTextBox"], {
            label: "Sender Email",
            placeholder: "Sender Email",
            modelValue: $setup.fromEmail,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.fromEmail) = $event)),
            disabled: !$props.info.allowEmailOverride
          }, null, 8 /* PROPS */, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode($setup["TableauTextBox"], {
            label: "Receiver Email",
            placeholder: "Receiver Email",
            modelValue: $setup.toEmail,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.toEmail) = $event)),
            disabled: !$props.info.allowEmailOverride
          }, null, 8 /* PROPS */, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode($setup["TableauTextBox"], {
            label: "Subject",
            placeholder: "Subject",
            modelValue: $setup.subject,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.subject) = $event))
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["TableauRichTextBox"], {
            placeholder: "Message",
            modelValue: $setup.message,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.message) = $event)),
            rows: 10
          }, null, 8 /* PROPS */, ["modelValue"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status", "statusMessage", "canSubmit"]))
}